<template>
  <EditItem
    model="year"
    :item="year"
    :status="status"
    :fields="fields"
  >
    <FormYearEdit
      :year="year"
      :id="id"
    />
  </EditItem>
</template>

<script>
import { mapState } from 'vuex';
import EditItem from '../../layouts/EditItem/EditItem';
import FormYearEdit from '../../components/FormYearEdit/FormYearEdit';

export default {
  name: 'YearEdit',
  props: {
    id: {
      type: String,
      required: true
    }
  },
  data() {
    return {
      fields: [
        'name',
        'description'
      ]
    };
  },
  components: {
    FormYearEdit,
    EditItem
  },
  mounted() {
    if (!Object.keys(this.year).length) {
      this.fetchYear(this.id);
    }
  },
  computed: {
    ...mapState({
      status: state => state.year.status,
    }),
    year() {
      const year = this.$store.getters['year/getById'](this.id)

      if (year) {
        return year;
      }

      return {};
    },
  },
  methods: {
    fetchYear(id) {
      this.$store.dispatch('year/FETCH', {
        id,
        num: 0
      });
    }
  }
};
</script>
